import { ALLOWED_TO_SHARE_LOCATION } from '../constants/actions/sharedActions';

export const setUserHasAllowedToShareLocation = () => ({
	type: ALLOWED_TO_SHARE_LOCATION,
	payload: {
		userHasAllowedToShareLocation: true,
	},
});
